var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-painel-lateral v-application" },
    [
      _c("transition", { attrs: { name: "ia-painel-slide" } }, [
        _vm.aberto
          ? _c(
              "aside",
              {
                staticClass: "ia-painel-lateral__superficie",
                attrs: { "aria-label": _vm.titulo }
              },
              [
                _c("header", { staticClass: "ia-painel-lateral__topo" }, [
                  _c(
                    "div",
                    { staticClass: "ia-painel-lateral__marca" },
                    [
                      _vm._t("marca", [
                        _c(
                          "div",
                          { staticClass: "ia-painel-lateral__avatar" },
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: "ia-w-mark",
                                size: 20,
                                color: "var(--aawz-green-color)"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "ia-painel-lateral__texto" }, [
                        _c(
                          "div",
                          { staticClass: "ia-painel-lateral__titulo" },
                          [_vm._v(_vm._s(_vm.titulo))]
                        ),
                        _vm.subtitulo
                          ? _c(
                              "div",
                              { staticClass: "ia-painel-lateral__subtitulo" },
                              [_vm._v(_vm._s(_vm.subtitulo))]
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center ia-painel-lateral__acoes"
                    },
                    [
                      _vm._t("acoes"),
                      _c(
                        "button",
                        {
                          staticClass: "ia-painel-lateral__botao",
                          attrs: {
                            type: "button",
                            "aria-label": _vm.rotuloRecolher,
                            title: _vm.rotuloRecolher
                          },
                          on: { click: _vm.fechar }
                        },
                        [
                          _c("icon-svg", {
                            staticClass: "ia-painel-lateral__seta--direita",
                            attrs: {
                              name: "arrow-down-new-ux",
                              size: 16,
                              color: "var(--neutral-700)"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "ia-painel-lateral__corpo" },
                  [_vm._t("default")],
                  2
                )
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "ia-painel-aba-fade" } }, [
        !_vm.aberto
          ? _c(
              "button",
              {
                staticClass: "ia-painel-lateral__aba",
                attrs: {
                  type: "button",
                  "aria-label": _vm.rotuloAbrir,
                  title: _vm.titulo
                },
                on: { click: _vm.abrir }
              },
              [
                _c("icon-svg", {
                  staticClass: "ia-painel-lateral__seta--esquerda",
                  attrs: {
                    name: "arrow-down-new-ux",
                    size: 16,
                    color: "var(--white)"
                  }
                }),
                _c("span", { staticClass: "ia-painel-lateral__aba-rotulo" }, [
                  _vm._v(_vm._s(_vm.rotuloAba))
                ])
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }